import {
  type Components,
  type Jsx,
  toJsxRuntime,
} from "hast-util-to-jsx-runtime";
import { Fragment } from "react";
// @ts-expect-error(ndhoule): Module is untyped
import { jsx, jsxs } from "react/jsx-runtime";
import { type BundledLanguage, codeToHast } from "shiki/bundle/web";

const SUPPORTED_LANGUAGES = [
  "angular-html",
  "angular-ts",
  "astro",
  "bash",
  "blade",
  "c",
  "c++",
  "coffee",
  "coffeescript",
  "cpp",
  "css",
  "glsl",
  "gql",
  "graphql",
  "haml",
  "handlebars",
  "hbs",
  "html",
  "html-derivative",
  "http",
  "imba",
  "jade",
  "java",
  "javascript",
  "jinja",
  "jison",
  "jl",
  "js",
  "json",
  "json5",
  "jsonc",
  "jsonl",
  "jsx",
  "julia",
  "less",
  "lit",
  "lua",
  "markdown",
  "marko",
  "md",
  "mdc",
  "mdx",
  "php",
  "postcss",
  "pug",
  "py",
  "python",
  "r",
  "rb",
  "regex",
  "regexp",
  "ruby",
  "sass",
  "scss",
  "sh",
  "shell",
  "shellscript",
  "sql",
  "styl",
  "stylus",
  "svelte",
  "text",
  "toml",
  "ts",
  "ts-tags",
  "tsx",
  "typescript",
  "vue",
  "vue-html",
  "wasm",
  "wgsl",
  "xml",
  "yaml",
  "yml",
  "zsh",
] as const satisfies (BundledLanguage | "text")[];

export type Language = (typeof SUPPORTED_LANGUAGES)[number];

const supportedLanguages = new Set<string>(SUPPORTED_LANGUAGES);

export const isSupportedLanguage = (value: string): value is Language =>
  supportedLanguages.has(value);

export const highlight = async (
  code: string,
  {
    components,
    language,
    theme,
  }: {
    components?: Partial<Components> | undefined;
    language: Language;
    theme: string;
  },
): Promise<React.JSX.Element> => {
  const out = await codeToHast(code, {
    lang: language,
    theme: theme,
  });

  return toJsxRuntime(out, {
    Fragment,
    jsx: jsx as Jsx,
    jsxs: jsxs as Jsx,
    components: components,
  });
};
